module.exports = __webpack_public_path__ + "media/images/flags/32/Libya-8854a325ff1e0202d516498baa47134e.png";